import styled from 'styled-components';

export const Container = styled.div``;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.6rem;
  height: 1.6rem;
  color: ${({ theme }) => theme.palette.text.primary};
  margin-right: ${({ theme }) => theme.spacing(1)}rem;
`;
